webpackJsonp([87],{

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SlideWithImage.l.scss","sourceRoot":""}]);

// exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("1cc1ae06", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/87.0b9138bb3262a1b9945b.js